<template>
  <div>
    <v-select multiple v-model="selected" :options="options"
                       :placeholder="placeholder">
      <span slot="no-options">-</span>
    </v-select>
  </div>

</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'MuseumFilter',
  components: {
    vSelect,
  },
  props: {
    initialId: Number,
    filterData: null,
    placeholder: String,
  },
  data() {
    return {
      selected: null,
      options: [],
    };
  },
  watch: {
    initialId(val) {
      const museum = this.filterData.find(m => m.id === val);
      this.selected = [{ id: museum.id, label: museum.title }];
    },
    selected(val) {
      this.$emit('input', val);
    },
    filterData(val) {
      const options = val.map(museum => ({ id: museum.id, label: museum.title }));
      options.sort((a, b) => a.label.localeCompare(b.label));
      this.options = options;
    },
  },
};
</script>
